/**
 * Injection token for providing a map of application error messages.
 *
 * This token is used to inject a `Record<string, string>` that contains the application's
 * error messages. The token serves as a dependency that can be configured and provided
 * throughout the application for consistent error management.
 *
 * @see Record<string, string> - The type representing the error messages map, where each key
 *                               is a unique error identifier and the value is the corresponding
 *                               error message.
 */
import { InjectionToken } from '@angular/core';
import { ErrorHandlerConfig } from '../models/errors.models';

export const ERROR_HANDLER_TOKEN = new InjectionToken<ErrorHandlerConfig>(
  'Error Messages'
);
